import { TimeSlot } from './TimeSlot';

export interface Day {
  dayOfWeek?: Day.DayOfWeekEnumType;
  openingHours?: Array<TimeSlot>;
}
export declare namespace Day {
  export type DayOfWeekEnumType = 'Lundi' | 'Mardi' | 'Mercredi' | 'Jeudi' | 'Vendredi' | 'Samedi' | 'Dimanche';
}

export const DayOfWeekEnum = {
  MONDAY: 'Lundi' as Day.DayOfWeekEnumType,
  TUESDAY: 'Mardi' as Day.DayOfWeekEnumType,
  WEDNESDAY: 'Mercredi' as Day.DayOfWeekEnumType,
  THURSDAY: 'Jeudi' as Day.DayOfWeekEnumType,
  FRIDAY: 'Vendredi' as Day.DayOfWeekEnumType,
  SATURDAY: 'Samedi' as Day.DayOfWeekEnumType,
  SUNDAY: 'Dimanche' as Day.DayOfWeekEnumType,
};
